import { render, staticRenderFns } from "./APITable.vue?vue&type=template&id=c3ef88ca&scoped=true"
import script from "./APITable.vue?vue&type=script&lang=js"
export * from "./APITable.vue?vue&type=script&lang=js"
import style0 from "./APITable.vue?vue&type=style&index=0&id=c3ef88ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ef88ca",
  null
  
)

export default component.exports